<template>
  <div v-loading="loading" class="page-form page-base">
    <h3 class="title">生产计划单</h3>

    <div class="form-container">
      <div class="tools">
        <form-button @click="$router.go(-1)">返回</form-button>
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        disabled
        label-width="100px"
        :model="conditions"
      >
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="生产计划编号">
              <el-input v-model="conditions.prodpl_id" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="prodpl_type" label="单据类型">
              <el-select v-model="conditions.prodpl_type" placeholder="">
                <el-option
                  v-for="item in selectDataOptions['A0006']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="name_soldto" label="订单客户">
              <el-input v-model="conditions.name_soldto" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="开票客户">
              <el-input v-model="conditions.name_billto" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select v-model="conditions.soldto_type" placeholder="">
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item prop="contactor" label="联系方式">
              <el-input v-model="conditions.contactor" />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item prop="sals_center" label="营销单元">
              <el-input v-model="conditions.centerktx" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="预约">
              <el-checkbox v-model="conditions.preorder" true-label="1" false-label="0" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="地址" prop="address">
              <el-input
                v-model="conditions.address"
                type="textarea"
                rows="2"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.remark"
                type="textarea"
                rows="2"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-date-picker
                v-model="conditions.datum"
                type="date"
                value-format="yyyyMMdd"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="制单人">
              <el-input v-model="conditions.uname" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-input v-model="conditions.status" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="生产计划单项目" :custome-config="() => vxeShowCustom('xTable')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'medium' }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #abclv="{ row }">
            <el-select v-model="row.abclv" disabled size="mini" placeholder="">
              <el-option
                v-for="selectItem in selectDataOptions['level']"
                :key="selectItem.value"
                :label="selectItem.name"
                :value="selectItem.value"
              />
            </el-select>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

  </div>
</template>
<script>
import { apiGetProdDetail } from '@/api/sap/make-plan'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
export default {
  data() {
    return {
      conditions: {
        prodpl_id: '',
        prodpl_type: '',
        sold_to: '',
        name_soldto: '',
        bill_to: '',
        name_billto: '',
        contactor: '',
        address: '',
        preorder: '',
        soldto_type: '',
        sals_center: '',
        datum: '',
        uname: '',
        status: '新建',
        remark: ''
      },
      selectDataOptions: {
        orgList: []
      },
      loading: false,
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 50 },
          {
            field: 'prod_id',
            title: '产品编号',
            width: 180
          },
          {
            field: 'description',
            title: '描述',
            width: 180
          },
          {
            field: 'wlybrand',
            title: '品牌',
            width: 180
          },
          {
            field: 'planqty_box',
            title: '数量（件）',
            width: 120
          },
          {
            field: 'planqty_bottle',
            title: '数量（瓶）',
            width: 120
          },
          {
            field: 'planqty_ton',
            title: '数量（吨）',
            width: 120
          },
          {
            field: 'area',
            title: '区域',
            width: 180
          },
          {
            field: 'abclv',
            title: '优先级',
            width: 180,
            slots: { default: 'abclv' }
          },
          {
            field: 'alv_box',
            title: '可用总量（件）',
            width: 180
          },
          // {
          //   field: 'boardNum',
          //   title: '看板确认（件）',
          //   width: 180,
          //   slots: { default: 'boardNum' },
          //   editRender: { name: 'input' }
          // },
          // {
          //   field: 'finalNum',
          //   title: '最终确认（件）',
          //   width: 180,
          //   slots: { default: 'finalNum' },
          //   editRender: { name: 'input' }
          // },
          {
            field: 'purmat_qty',
            title: '采购中数量（件）',
            width: 180
          },
          {
            field: 'pur_date',
            title: '采购到货日期',
            width: 180
          },
          {
            field: 'remark',
            title: '备注',
            width: 180
            // slots: { default: 'remark' }
            // editRender: { name: 'input' }
          }
        ],
        data: []
      },
      currentRow: {}
    }
  },
  created() {
    // 生产计划单据类型
    this.getSelectDictDataOrigin('A0006')
    // 客户类型
    this.getSelectDictDataOrigin('A0009')
    this.getSelectDictDataOrigin('A0008')
    this.getSelectDictDataOrigin('level')
    this.queryData()
  },
  methods: {

    async queryData() {
      const { head, item } = await apiGetProdDetail({ prodpl_id: this.$route.query.id })
      Object.assign(this.conditions, head)
      this.gridOptions.data = item
    },

    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 10px;
  text-align: left;
  position: relative;
  .btn-header {
    background: #fff;
    position: fixed;
    transform: translate(-10px, -10px);
    z-index: 99;
    width: calc(100% - 273px);
    height: 50px;
    padding: 5px 0 0 10px;
    box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/make-plan-manage/components/makePlanOrderCheck.vue